import React from 'react';
import Button from '../../components/@base/Button';

/**
 * Botão para visualização de ajuda
 * @param {*} props
 * @returns
 */
const ComponentConfigurationHelpButton = (props) => {
  const clickHandler = () => {
    props.setState({ showHelperDialog: true });
  };

  return (
    <Button
      circle
      small
      title="Como funciona esse componente?"
      onClick={clickHandler}
    >
      <i className="far fa-question-circle" aria-hidden="true" />
    </Button>
  );
};

export default ComponentConfigurationHelpButton;
